import React from "react";
import Popup from "../../index";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {
	isUserListAddCollaboratorsPopupShown
} from "../../../../../actions/popupActions";
import AddCollaboratorsField
	from "../../../../screens/sharing/components/sharing-details-popup/components/add-collaborators-popup/components/add-collaborators-field";
import UpdateDirectory
	from "../../../../screens/sharing/components/sharing-details-popup/components/add-collaborators-popup/components/update-directory";
import RightSelection
	from "../../../../screens/sharing/components/sharing-details-popup/components/add-collaborators-popup/components/right-selection";
import AutoCompletion
	from "../../../../screens/sharing/components/sharing-details-popup/components/add-collaborators-popup/components/auto-completion";
import AddToContact
	from "../../../../screens/sharing/components/sharing-details-popup/components/add-collaborators-popup/components/add-to-contact";
import Notify
	from "../../../../screens/sharing/components/sharing-details-popup/components/add-collaborators-popup/components/notify";
import SharingButton
	from "../../../../screens/sharing/components/sharing-details-popup/components/add-collaborators-popup/components/sharing-button";
import {
	hasDuplicatedEmail as setHasDuplicatedEmail,
	isEmailValid as setIsEmailValid,
	isEmpty as setIsEmpty
} from "../../../../../actions/addCollaboratorActions";
import {
	autoCompleteEnteredValue as setAutoCompleteEnteredValue,
	getAddedCollaborators,
	share
} from "../../../../../actions/sharingDetailsActions";
import {labelStateUpdating, postCreateLabel} from "../../../../../actions/contactsGroupItemActions";
import SelectLabelToAdd from "./components/select-label-to-add";
import MsgSharingDetailsBar
	from "../../../../screens/sharing/components/sharing-details-popup/components/add-collaborators-popup/components/msg-sharing-details-bar";

function UserListAddCollaboratorsPopup () {

	const findLabels = useSelector(state => state.contactsGroupItemReducer.findLabels);
	const isEmpty = useSelector(state => state.addCollaboratorDetailsReducer.isEmpty);
	const isEmailValid = useSelector(state => state.addCollaboratorDetailsReducer.isEmailValid);
	const hasDuplicatedEmail = useSelector(state => state.addCollaboratorDetailsReducer.hasDuplicatedEmail);
	const autoCompleteEnteredValue = useSelector(state => state.sharingDetailsReducer.autoCompleteEnteredValue);
	const addedCollaborators = useSelector(state => state.sharingDetailsReducer.getAddedCollaborators);
	const autoComplete = useSelector(state => state.sharingDetailsReducer.getAutoComplete);
	const sharingDetailsPopup = useSelector(state => state.sharingDetailsReducer.getSharingDetailsPopup);
	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const targetedContact = useSelector(state => state.contactReducer.targetedContact);
	const rightToAdd = useSelector(state => state.sharingDetailsReducer.rightToAdd);
	const selectOneLabelFromPopup = useSelector(state => state.contactsGroupItemReducer.selectOneLabelFromPopup);
	const msgSharingDetailsBar = useSelector(state => state.msgBarReducer.msgSharingDetailsBar);

	const { t } = useTranslation();

	const dispatch = useDispatch();
	const close = () => {
		dispatch(isUserListAddCollaboratorsPopupShown(false))
	};

	const addCollaborator = (e) => {

		document.getElementById('addCollaboratorsField').focus();

		dispatch(setAutoCompleteEnteredValue(""));

		if(isEmpty){
			dispatch(setIsEmpty(false));
		}

		if(isEmailValid === false){
			dispatch(setIsEmailValid(true));
		}

		if(hasDuplicatedEmail){
			dispatch(setHasDuplicatedEmail(false));
		}

		/*
		* If a click event is triggered
		* */

		let collaboratorsArray = [];

		autoComplete.forEach(item => {

			if(item.id === e.currentTarget.id){
				collaboratorsArray = collaboratorsArray.concat({
					"groupId": selectOneLabelFromPopup?.id || sharingDetailsPopup[2] || selectedContactsGroup?.id,
					"id": item.id ? item.id : item.email,
					"name": item.name,
					"email": item.email,
					"permission": rightToAdd,
					"type": item.type,
					"addToContact": false,
					"toRemove": false
				});
			}

			return collaboratorsArray;
		});

		dispatch(getAddedCollaborators(...collaboratorsArray));
		document.getElementById("addCollaboratorsField").value = "";
	};

	const handleShare = () => {

		if(sharingDetailsPopup[2]){
			dispatch(labelStateUpdating(sharingDetailsPopup[2]));
		} else if (selectedContactsGroup) {
			dispatch(labelStateUpdating(selectedContactsGroup.id));
		} else if (selectOneLabelFromPopup) {
			dispatch(labelStateUpdating(selectOneLabelFromPopup.id));
		} else {
			console.error('No selected label found')
		}

		if(document.getElementById("addCollaboratorsField").value.trim() === "" && addedCollaborators.length === 0){
			setIsEmpty(true);
		} else if (targetedContact && findLabels.contactsGroups.length === 0) {

			/*
			* TargetedContact with no label
			* */

			dispatch(postCreateLabel('🥳 My First Shared Group', true));

		} else {
			dispatch(share());
		}

	};

	return (
		<Popup onClose={close}>
			<div className="add-collaborators position-relative">
				<div>
					<div className="d-flex align-items-center mb-3">
						<div
							className="pic bg-primary rounded-circle d-flex align-items-center justify-content-center mr-2 text-center">
							<svg width="1em" height="1em" viewBox="0 0 16 16">
								<line fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
									  x1="5.425" y1="9.046" x2="10.575" y2="11.62"/>
								<line fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
									  x1="5.425" y1="6.954" x2="10.575" y2="4.379"/>
								<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
									  d="M15,3.334c0,1.287-1.046,2.332-2.333,2.332 s-2.334-1.045-2.334-2.332C10.333,2.046,11.38,1,12.667,1S15,2.046,15,3.334"/>
								<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
									  d="M15,12.667C15,13.954,13.954,15,12.667,15 s-2.334-1.046-2.334-2.333s1.047-2.334,2.334-2.334S15,11.38,15,12.667"/>
								<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
									  d="M5.666,8c0,1.287-1.045,2.333-2.332,2.333 C2.046,10.333,1,9.287,1,8s1.046-2.334,2.334-2.334C4.62,5.666,5.666,6.713,5.666,8"/>
							</svg>
						</div>
						<h2>
							Share with people and groups
						</h2>
					</div>
					<div className="d-flex align-items-stretch mb-2">
						<div className={`input-group`}>
							<div className="input-wrapper d-flex p-1">
								<AddCollaboratorsField launchShare={handleShare}/>
							</div>
							<div className="input-group-append">
								<UpdateDirectory/>
							</div>
						</div>
						{
							addedCollaborators.length
								?
								<RightSelection/>
								:
								null
						}
					</div>
					{
						isEmpty
							?
							<div className="alert alert-danger mt-3">{t("fieldEmpty")}.</div>
							:
							isEmailValid === false
								?
								<div
									className="alert alert-danger mt-3">{t("popupSharingInvalidEmailError")}.</div>
								:
								hasDuplicatedEmail
									?
									<div className="alert alert-danger mt-3">{t("emailExistAlreadyText")}
									</div>
									:
									null
					}
					{
						autoCompleteEnteredValue.length > 1
							?
							<AutoCompletion
								addCollaboratorClickHandler={addCollaborator}
							/>
							:
							null
					}
					<AddToContact/>
					<Notify/>
					<SelectLabelToAdd/>
					<SharingButton />
				</div>
				{
					msgSharingDetailsBar.length > 0
					&& <MsgSharingDetailsBar/>
				}
			</div>
		</Popup>
	)
}

export default UserListAddCollaboratorsPopup;
